import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getCategoryOptions } from './Categories';
import { useStrategy } from '../../../hooks/useStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
const CategorySelect = ({
  value,
  onChange
}) => {
  const {
    getFilterFamilyOptions
  } = useStrategy();
  const filterFamilyOptions = getFilterFamilyOptions();
  const categories = getCategoryOptions();
  const enabledCategories = categories.filter(category => filterFamilyOptions.find(option => option.category === category.id));
  return /*#__PURE__*/_jsx(Tabs, {
    selected: value,
    onSelectedChange: onChange,
    fill: enabledCategories.length > 1,
    children: enabledCategories.map(option => /*#__PURE__*/_jsx(Tab, {
      tabId: option.id,
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: option.messageKey
      })
    }, option.id))
  });
};
export default CategorySelect;